import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
//primereact
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import CardProgressProfile from "../../../components/cards/CardProgressProfile";
//images
import profile from "../../../assets/default.jpg";
//services
import { getProgressTrainings } from "../../../services/Trainings/getProgressTrainings";
import { useAppContext } from "../../../context/AppContext";

const ProgressSquad = () => {
  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link to={"/trainings"} className="p-breadcrumb-link">
          Treinamentos
        </Link>
      ),
    },
    {
      template: () => (
        <Link to={"/trainings/progress"} className="p-breadcrumb-link">
          Progresso da Equipe
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/trainings"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data: dataProgress, isLoading } = useQuery({
    queryKey: ["progress_squad"],
    queryFn: () => getProgressTrainings(),
    enabled: !!permissions?.includes("4"),
  });

  return (
    <>
      <div className="col-md-12">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="text-center">
        <h1>Progresso da Equipe</h1>
        <h4>Acompanhe por aqui como anda os treinamentos da sua equipe</h4>
      </div>
      <div className="row text-items justify-content-center d-flex flex-wrap gap-3  pt-3 pb-3">
        {isLoading ? (
          <Skeleton width="100%" height="400px"></Skeleton>
        ) : (
          dataProgress &&
          Object.keys(dataProgress).map((u, i) => {
            const user = dataProgress[u];
            //            // console.log(user);
            return (
              <CardProgressProfile
                key={i}
                name={user.name}
                image={user.photo_profile ? user.photo_profile : profile}
                type={user.role}
                email={user.email}
                valueBroker={
                  user.progress["treinamento_corretor"] &&
                  user.progress["treinamento_corretor"].percentage_completed
                    ? user.progress[
                        "treinamento_corretor"
                      ].percentage_completed.toFixed(0)
                    : 0
                }
                valueHousing={
                  user.progress["treinamento_imobiliaria"] &&
                  user.progress["treinamento_imobiliaria"].percentage_completed
                    ? user.progress[
                        "treinamento_imobiliaria"
                      ].percentage_completed.toFixed(0)
                    : 0
                }
                valueFinance={
                  user.progress["treinamento_financeiro"] &&
                  user.progress["treinamento_financeiro"].percentage_completed
                    ? user.progress[
                        "treinamento_financeiro"
                      ].percentage_completed.toFixed(0)
                    : 0
                }
                valueAdmin={
                  user.progress["treinamento_administrador"] &&
                  user.progress["treinamento_administrador"]
                    .percentage_completed
                    ? user.progress[
                        "treinamento_administrador"
                      ].percentage_completed.toFixed(0)
                    : 0
                }
              />
            );
          })
        )}
      </div>
    </>
  );
};

export default ProgressSquad;
